var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsRedDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56006 15.58L10.2801 22.14L16.0001 28.71L21.7201 22.14L27.4401 15.58H22.2301V3.29004H9.77006V15.58H4.56006Z",
    fill: "#CC4848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsRedDownArrow);
export default __webpack_public_path__ + "static/media/beemg-icons-red-down-arrow.8b968c29e6df87667a596ceb16744116.svg";
export { ForwardRef as ReactComponent };